/* ==========================================================================
   DECKO Cashback Landing Page Scripts
   Namespace: window.DCB
   Handles: FAQ accordion, copy referral link, share buttons,
            referral tracking (cookie + cart attribute)
   ========================================================================== */

(function () {
  'use strict';

  // Configuration
  var DCB_CONFIG = {
    cookieName: 'decko_ref',
    cookieDays: 30,
    cartAttributeKey: 'Referred by',
    cartUpdateUrl: '/cart/update.js'
  };

  // Public namespace
  window.DCB = window.DCB || {};

  // ==========================================================================
  // FAQ Accordion
  // ==========================================================================
  DCB.initFAQ = function () {
    var items = document.querySelectorAll('.dcb-faq__item');
    if (!items.length) return;

    items.forEach(function (item) {
      var question = item.querySelector('.dcb-faq__q');
      if (!question) return;

      question.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        // Close all others
        items.forEach(function (other) {
          other.classList.remove('is-open');
        });

        // Toggle current
        if (!isOpen) {
          item.classList.add('is-open');
        }
      });
    });
  };

  // ==========================================================================
  // Copy referral link to clipboard
  // ==========================================================================
  DCB.copyLink = function (inputId, buttonEl) {
    var input = document.getElementById(inputId);
    if (!input) return;

    // Modern clipboard API with fallback
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(input.value)
        .then(function () {
          DCB._showCopyFeedback(buttonEl);
        })
        .catch(function () {
          DCB._legacyCopy(input, buttonEl);
        });
    } else {
      DCB._legacyCopy(input, buttonEl);
    }
  };

  DCB._legacyCopy = function (input, buttonEl) {
    input.select();
    input.setSelectionRange(0, 99999);
    try {
      document.execCommand('copy');
      DCB._showCopyFeedback(buttonEl);
    } catch (err) {
      console.warn('DCB: copy failed', err);
    }
  };

  DCB._showCopyFeedback = function (buttonEl) {
    if (!buttonEl) return;
    var original = buttonEl.textContent;
    buttonEl.textContent = 'Copied';
    setTimeout(function () {
      buttonEl.textContent = original;
    }, 1800);
  };

  // ==========================================================================
  // Referral tracking
  // Reads ?ref= from URL, sets cookie, attaches to cart
  // Runs on every page where dcb.js is loaded
  // ==========================================================================
  DCB.trackReferrer = function () {
    var params = new URLSearchParams(window.location.search);
    var refId = params.get('ref');

    if (refId && /^[a-zA-Z0-9_-]+$/.test(refId)) {
      DCB._setCookie(DCB_CONFIG.cookieName, refId, DCB_CONFIG.cookieDays);
    }
  };

  DCB._setCookie = function (name, value, days) {
    var expires = new Date(Date.now() + days * 86400000).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) +
      '; expires=' + expires + '; path=/; SameSite=Lax';
  };

  DCB._getCookie = function (name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  };

  // ==========================================================================
  // Attach referrer to cart (so it lands on the order in admin)
  // Called once on every page load if cookie exists
  // ==========================================================================
  DCB.attachToCart = function () {
    var refId = DCB._getCookie(DCB_CONFIG.cookieName);
    if (!refId) return;

    var payload = { attributes: {} };
    payload.attributes[DCB_CONFIG.cartAttributeKey] = refId;

    fetch(DCB_CONFIG.cartUpdateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).catch(function () {
      // Silent fail. Cart may not be initialized yet, harmless.
    });
  };

  // ==========================================================================
  // Share button helpers (build share URLs with the referral link)
  // ==========================================================================
  DCB.shareUrl = function (platform, link, message) {
    var encodedLink = encodeURIComponent(link);
    var encodedMsg = encodeURIComponent(message || 'Check out DECKO');

    switch (platform) {
      case 'whatsapp':
        return 'https://wa.me/?text=' + encodedMsg + '%20' + encodedLink;
      case 'email':
        return 'mailto:?subject=' + encodedMsg +
               '&body=' + encodedMsg + '%20' + encodedLink;
      case 'sms':
        return 'sms:?body=' + encodedMsg + '%20' + encodedLink;
      case 'facebook':
        return 'https://www.facebook.com/sharer/sharer.php?u=' + encodedLink;
      default:
        return link;
    }
  };

  // ==========================================================================
  // Init on DOM ready
  // ==========================================================================
  function dcbInit() {
    DCB.trackReferrer();
    DCB.attachToCart();
    DCB.initFAQ();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', dcbInit);
  } else {
    dcbInit();
  }
})();